import { LimitOrderTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/entries/LimitOrderTacticPanel';
import { LimitOrderWrapper } from '../../../../components/displays/tradeplans/softOrderModules/entryTacticModules/LimitOrderModule/wrapper/LimitOrderWrapper';
import LimitOrderDocs from '../../../../components/forms/tradeplans/documentation/LimitOrderDocumentation';
import LimitOrderModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/entryTactics/modules/LimitOrderModule';
import { LimitOrderData } from './limitOrderData';
import { validateLimitOrder } from './validateLimitOrder';

export const LimitOrder = {
  //data class
  dataStore: LimitOrderData,

  //string constants
  name: 'LIMIT_ORDER',
  tacticLabel: 'Limit Order',
  addTacticLabel: 'Add Limit Order',
  category: 'Entry',

  // components
  tradePlanFormModule: LimitOrderModule,
  tacticPanel: LimitOrderTacticPanel,
  addTacticPanel: null,
  wrapper: LimitOrderWrapper,
  chartSoftOrderComponent: null,
  documentation: LimitOrderDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null, //todo
  validationFunction: validateLimitOrder,
};
